import * as React from 'react';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {FormEditor} from './form-editor';

import styles from './form-editor-main-content.module.css';

export type AfterSubmissionType = 'redirectUrl' | 'message';

type Props = {
    formId: string;
    formHeader?: React.ReactNode;
    control: Control;
    watch: Watch;
    postAddField: () => Promise<any>;
    saveFailedErrorMessage: string | null | undefined;
    onClearError: () => void;
    disableDesign?: boolean;
    disableHeaderFields?: boolean;
    minimumOneEmailField?: boolean;
    isMeetingForm?: boolean;
};

export function FormEditorMainContent(props: Props) {
    const backgroundColor = props.watch('backgroundColor');

    return (
        <div style={{backgroundColor}} className={styles['main-content']}>
            <FormEditor
                formId={props.formId}
                formHeader={props.formHeader}
                control={props.control}
                watch={props.watch}
                postAddField={props.postAddField}
                saveFailedErrorMessage={props.saveFailedErrorMessage}
                onClearError={props.onClearError}
                disableDesign={props.disableDesign}
                disableHeaderFields={props.disableHeaderFields}
                minimumOneEmailField={props.minimumOneEmailField}
                isMeetingForm={props.isMeetingForm}
            />
        </div>
    );
}
